import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const familyOfficeAllocationService = createApi({
    reducerPath: 'familyOfficeAllocationService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['FamilyOfficeAllocation'],
    endpoints: (builder) => ({
        getAllFamilyOfficeAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeAllocationController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        saveFamilyOfficeAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeAllocationController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        updateFamilyOfficeAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeAllocationController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        deleteFamilyOfficeAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeAllocationController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
        getFamilyOfficeAllocationById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeAllocationController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
        bulkUploadFamilyOfficeAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeAllocationController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllFamilyOfficeAllocation: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeAllocationController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                };
            },
        }),
    }),
});

export const {
    useGetAllFamilyOfficeAllocationMutation,
    useSaveFamilyOfficeAllocationMutation,
    useUpdateFamilyOfficeAllocationMutation,
    useDeleteFamilyOfficeAllocationMutation,
    useGetFamilyOfficeAllocationByIdMutation,
    useBulkUploadFamilyOfficeAllocationMutation,
    useFindAllFamilyOfficeAllocationMutation,
} = familyOfficeAllocationService;
